import { render, staticRenderFns } from "./CFtOrderDetails.vue?vue&type=template&id=3c92dea9&scoped=true"
import script from "./CFtOrderDetails.vue?vue&type=script&lang=ts"
export * from "./CFtOrderDetails.vue?vue&type=script&lang=ts"
import style0 from "./CFtOrderDetails.vue?vue&type=style&index=0&id=3c92dea9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c92dea9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
